export function ResolutionIcon({ active }: any) {
  const color: string = active ? "#006AB3" : "#000000";
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.12061 5.26758H0V0.479004C0 0.215332 0.215332 0 0.479004 0H3.82031V1.12207H1.12061V5.26758ZM5.71436 14.231H0.479004C0.213867 14.231 0 14.0156 0 13.749V8.27783H5.71436V14.231ZM7.87939 1.10889V0H11.7378V1.10889H7.87939ZM14.6001 0H17.521C17.7861 0 18 0.215332 18 0.479004V5.27344H16.8794V1.10889H14.6001V0ZM18 8.35986V13.7505C18 14.0156 17.7847 14.2295 17.521 14.2295H14.6001V13.1104H16.8823C16.8823 11.6733 16.8823 9.79834 16.8823 8.35986H18ZM11.7393 14.231H7.87354V13.1104H11.7393V14.231Z"
        fill={color}
      />
    </svg>
  );
}
